import { Controller } from "stimulus";

// Shows the schedule datetime field only while the "scheduled" status is selected in the editor.
export default class extends Controller {
  static targets = ["radio", "fields"];

  connect() {
    this.toggle();
  }

  toggle() {
    const selected = this.radioTargets.find((radio) => radio.checked);
    this.fieldsTarget.hidden = !selected || selected.value !== "scheduled";
  }
}
